// update state
const setCurrentObject = (payload) => {
    return {
        type: "ALLOBJECT",
        payload
    }
}

export default setCurrentObject;


// WEBPACK FOOTER //
// ./src/actions/setCurrentObject.js